<template>
  <footer class="app-footer">
      <div v-show="hideSct">
        <a >SCT</a> &copy; 2019 R&D
        <span class="float-right">Powered by SCT</span>
      </div>
  </footer>
</template>
<script>
import Cookies from 'js-cookie';

export default {
    name: 'footerApp',
    data() {
      return {
          hideSct: !Cookies.get('hide_sct')?true:false
      }
    }
}
</script>



// WEBPACK FOOTER //
// Footer.vue?48ad90b5